var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-main",style:({'background-color': _vm.msgType.bgColor, color: _vm.msgType.color})},[_c('van-icon',{attrs:{"name":_vm.msgType.icon,"color":_vm.msgType.color,"size":"60"}}),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }